import React from "react";
import PurchaseService from "services/purchase";

import { connect } from "react-redux";
import { load } from "reducers/purchase";

class Order extends React.Component {
  purchaseService = new PurchaseService();

  constructor() {
    super(...arguments);
    this.load();
  }

  async load() {
    await this.purchaseService
      .getAll()
      .then(({ data }) => this.props.load(data));
  }

  render() {
    return null;
  }
}

export default connect(null, { load })(Order);
